"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicCountry = exports.BasicSlug = exports.BasicLastname = exports.BasicFirstname = exports.BasicEULA = exports.BasicPhone = exports.BasicOTP = exports.BasicPassword = exports.BasicEmail = exports.BasicAudience = void 0;
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.BasicAudience = zod_1.z.nativeEnum(shared_1.EnumAudience).default(shared_1.EnumAudience.web).optional();
exports.BasicEmail = zod_1.z.string({
  errorMap: () => ({
    message: 'email_invalid'
  })
}).email().toLowerCase().trim();
exports.BasicPassword = zod_1.z.string().trim().min(3, `password_invalid`).refine(val => val.length > 0, {
  message: 'password_required'
});
exports.BasicOTP = zod_1.z.number({
  errorMap: () => ({
    message: 'otp_invalid'
  })
});
exports.BasicPhone = zod_1.z.string({
  errorMap: () => ({
    message: 'mobile_phone_invalid'
  })
}).trim().min(5, `mobile_phone_invalid`).refine(value => /^\+[0-9]+$/.test(value !== null && value !== void 0 ? value : ""), `mobile_phone_invalid`);
exports.BasicEULA = zod_1.z.literal(true, {
  errorMap: () => ({
    message: `accept_sla_invalid`
  })
});
exports.BasicFirstname = zod_1.z.string().trim().min(2, "first_name_invalid").refine(value => /^[a-zA-Zа-яА-Я]+$/.test(value !== null && value !== void 0 ? value : ""), `first_name_invalid`);
exports.BasicLastname = zod_1.z.string().trim().min(2, "last_name_invalid").refine(value => /^[a-zA-Zа-яА-Я]+$/.test(value !== null && value !== void 0 ? value : ""), `last_name_invalid`);
exports.BasicSlug = zod_1.z.string().min(3, "slug_invalid").toLowerCase().trim().refine(value => /^[A-Za-zА-Яа-я\.\_0-9]+$/.test(value !== null && value !== void 0 ? value : ""), `slug_invalid`);
exports.BasicCountry = zod_1.z.string().trim().min(1, "country_invalid");
